import PropTypes from 'prop-types';
import React from 'react';
import HotelSearchPrefsModal from './HotelSearchPrefsModal';

class HotelSearchPrefs extends React.Component {
  componentWillMount() {
    if (this.props.brandList.length === 0) {
      this.props.requestBrandOptions();
    }
  }
  render() {
    if (this.props.show) {
      return (
        <HotelSearchPrefsModal
          groups={this.props.groups}
          brandList={this.props.brandList}
          savePreferences={this.props.saveSearchPreferences}
          show={this.props.show}
          onClose={this.props.onClose}
        />
      );
    }
    return null;
  }
}

HotelSearchPrefs.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  brandList: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  requestBrandOptions: PropTypes.func.isRequired,
  saveSearchPreferences: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

HotelSearchPrefs.defaultProps = {
  brandList: [],
};

export default HotelSearchPrefs;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSearchPrefs.js